








import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'ContentChannelIndex'
})
export default class extends Vue {}
